var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3147.783251231527,
    height: 993.9106853807398,
    viewBox: "0 0 3147.783251231527 993.9106853807398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(7.389162561576355) translate(10, 10)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs22062"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient22069"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop22070",
    stopColor: "#616161",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop22071",
    stopColor: "#e6e7e8",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop22072",
    stopColor: "#616161",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient22073"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop22074",
    stopColor: "#f5ec9b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop22075",
    stopColor: "#905e26",
    offset: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG22063",
    featureKey: "symbolFeature-0",
    transform: "matrix(1.2446657183499288,0,0,1.2446657183499288,0,0)",
    fill: "url(#SvgjsLinearGradient22069)"
  }, /*#__PURE__*/React.createElement("title", {
    xmlns: "http://www.w3.org/2000/svg"
  }, "Letter E_Logo-07"), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-2962.000000, -1007.000000)",
    fill: "url(#SvgjsLinearGradient22069)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Letter-E_Logo-07",
    transform: "translate(2962.000000, 1007.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,18.5805896 C40.1113436,18.5805896 43.1962901,18.675649 46.2530797,18.8921732 C55.7912485,19.5012574 65.0707253,21.0574148 74,23.4796688 L74,4.8990792 C65.0724851,2.47682516 55.7912485,0.920667776 46.2548395,0.311583549 C43.1962901,0.0950593879 40.1113436,0 37,0 C30.7227586,0 24.5546254,0.406642937 18.4938407,1.20408558 C12.1884423,2.02969397 6.02030916,3.26194529 0,4.8990792 L0,23.4796688 L0,31.3836809 L0,40.4917785 L0,50.0047588 L0,59.861009 C6.62920333,62.9733238 12.8254935,66.8443533 18.4938407,71.3508724 C20.9822117,73.3259953 23.3773127,75.4384261 25.6509869,77.6564785 C29.8446136,81.7299493 33.6458026,86.1959802 37.0017598,91 C39.7892985,87.0075057 42.8865636,83.2597013 46.2548395,79.767149 C46.9306064,79.0506829 47.6345303,78.3465393 48.3507729,77.6564785 C55.805327,70.3897164 64.463591,64.3411228 74,59.861009 L74,50.0047588 L74,40.4917785 C69.2115577,42.3454366 64.5709394,44.5106782 60.1326992,46.9875034 C55.2633056,49.6808527 50.6226873,52.7385964 46.2530797,56.1220064 C43.0203092,58.5988316 39.9353627,61.2640152 37,64.0788293 C31.3721284,58.6657252 25.1617598,53.8353 18.4938407,49.7072581 L18.4938407,46.3097652 C24.5546254,45.5105622 30.7227586,45.1056796 37,45.1056796 C40.1113436,45.1056796 43.1962901,45.200739 46.2530797,45.4172631 L46.2530797,26.7944249 C43.1962901,26.5779007 40.1113436,26.4828413 37,26.4828413 C30.7227586,26.4828413 24.5546254,26.8894843 18.4938407,27.6869269 L18.4938407,19.7829148 C24.5546254,18.9872326 30.7227586,18.5805896 37,18.5805896 Z",
    id: "Path"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG22064",
    featureKey: "textGroupContainer",
    transform: "matrix(1,0,0,1,405,28)",
    fill: "url(#SvgjsRadialGradient22073)"
  }, /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    y: 0,
    height: 1,
    width: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    y: 0,
    x: -293,
    width: 3,
    height: 58
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG22065",
    featureKey: "nameFeature-0",
    transform: "matrix(1.0338948617621386,0,0,1.0338948617621386,128.51118887490514,32.661051382378616)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.56 25.119999999999997 c0.74668 0 1.12 -0.37332 1.12 -1.12 s-0.37332 -1.12 -1.12 -1.12 l-30.88 0 l0 -9.76 l30.88 0 c0.74668 0 1.12 -0.37332 1.12 -1.12 s-0.37332 -1.12 -1.12 -1.12 l-33.12 0 l0 26.24 l33.12 0 c0.74668 0 1.12 -0.37332 1.12 -1.12 s-0.37332 -1.12 -1.12 -1.12 l-30.88 0 l0 -9.76 l30.88 0 z M75.76 22.88 l-30.88 0 l0 -9.76 l30.88 0 c0.74668 0 1.12 -0.37332 1.12 -1.12 s-0.37332 -1.12 -1.12 -1.12 l-33.12 0 l0 25.12 c0 0.74668 0.37332 1.12 1.12 1.12 s1.12 -0.37332 1.12 -1.12 l0 -10.88 l30.88 0 c0.74668 0 1.12 -0.37332 1.12 -1.12 s-0.37332 -1.12 -1.12 -1.12 z M83.52000000000001 12.239999999999998 l0 24 c0 0.72 0.36 1.08 1.08 1.08 c0.74668 0 1.12 -0.36 1.12 -1.08 l0 0 l0 -24 c0 -0.74668 -0.37332 -1.12 -1.12 -1.12 c-0.72 0 -1.08 0.37332 -1.08 1.12 z M125.64 11.120000000000001 c-0.74668 0 -1.12 0.37332 -1.12 1.12 l0 21.76 l-32 -24 l0 26.24 c0 0.72 0.37332 1.08 1.12 1.08 s1.12 -0.36 1.12 -1.08 l0 -21.8 l32 24 l0 -26.2 c0 -0.74668 -0.37332 -1.12 -1.12 -1.12 z M158.56 10.879999999999999 l-25.12 0 l0 25.12 c0 0.74668 0.37332 1.12 1.12 1.12 s1.12 -0.37332 1.12 -1.12 l0 -6.88 l22.88 0 c2.5333 0 4.6868 -0.89332 6.46 -2.68 s2.66 -3.9334 2.66 -6.44 c0 -2.5333 -0.88668 -4.6868 -2.66 -6.46 s-3.9266 -2.66 -6.46 -2.66 z M158.56 26.880000000000003 l-22.88 0 l0 -13.76 l22.88 0 c1.8933 0 3.5133 0.67332 4.86 2.02 s2.02 2.9667 2.02 4.86 s-0.67332 3.5133 -2.02 4.86 s-2.9667 2.02 -4.86 2.02 z M208.4 35.08 l-8.96 -5.96 l0.32 0 c2.5333 0 4.6868 -0.89332 6.46 -2.68 s2.66 -3.9334 2.66 -6.44 c0 -2.5333 -0.88668 -4.6868 -2.66 -6.46 s-3.9266 -2.66 -6.46 -2.66 l-25.12 0 l0 25.12 c0 0.74668 0.37332 1.12 1.12 1.12 s1.12 -0.37332 1.12 -1.12 l0 -6.88 l18.56 0 l11.72 7.8 c0.18668 0.13332 0.38668 0.2 0.6 0.2 c0.4 0 0.70668 -0.17332 0.92 -0.52 c0.13332 -0.18668 0.2 -0.38668 0.2 -0.6 c0 -0.4 -0.16 -0.70668 -0.48 -0.92 z M176.88 13.120000000000001 l22.88 0 c1.8933 0 3.5133 0.67332 4.86 2.02 s2.02 2.9667 2.02 4.86 s-0.67332 3.5133 -2.02 4.86 s-2.9667 2.02 -4.86 2.02 l-22.88 0 l0 -13.76 z M233.12 10.440000000000001 c-4.8532 0 -9.0132 1.32 -12.48 3.96 c-3.5467 2.6933 -5.32 5.9732 -5.32 9.84 s1.7733 7.1468 5.32 9.84 c3.44 2.6133 7.6 3.92 12.48 3.92 s9.0268 -1.3067 12.44 -3.92 c3.5467 -2.72 5.32 -6 5.32 -9.84 s-1.7733 -7.12 -5.32 -9.84 c-3.4667 -2.64 -7.6132 -3.96 -12.44 -3.96 z M248.67999999999998 24.240000000000002 c0 3.1733 -1.52 5.8868 -4.56 8.14 s-6.7068 3.38 -11 3.38 s-7.96 -1.1267 -11 -3.38 s-4.56 -4.9668 -4.56 -8.14 c0 -3.2 1.52 -5.9268 4.56 -8.18 s6.7068 -3.38 11 -3.38 s7.96 1.1267 11 3.38 s4.56 4.98 4.56 8.18 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.de9c7a525fe7863631587968b75b8d3f.svg";
export { ForwardRef as ReactComponent };